/** @flow */
import formatDate from 'utils/date/formatDate';


export default function renderDateCell(date) {
  return formatDate(date, '-');
}
